import * as Actions from './AddSuperDealActionTypes';

const initialState = {
  superDealCreate: {
    loading: false,
    error: { status: false, message: '' },
    data: null
  },
  superDeals: {
    loading: false,
    error: { status: false, message: '' },
    data: []
  }
};

export const addSuperDealReducer = (state = initialState, action) => {
  switch (action.type) {
    // Create Super Deal
    case Actions.CREATE_SUPER_DEAL:
      return {
        ...state,
        superDealCreate: {
          ...state.superDealCreate,
          loading: true,
          error: { status: false, message: '' }
        }
      };
    case Actions.CREATE_SUPER_DEAL_SUCCESS:
      return {
        ...state,
        superDealCreate: {
          ...state.superDealCreate,
          loading: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };
    case Actions.CREATE_SUPER_DEAL_FAILS:
      return {
        ...state,
        superDealCreate: {
          ...state.superDealCreate,
          loading: false,
          error: { status: true, message: action.payload }
        }
      };

    // Fetch Super Deals
    case Actions.FETCH_SUPER_DEALS:
      return {
        ...state,
        superDeals: {
          ...state.superDeals,
          loading: true,
          error: { status: false, message: '' }
        }
      };
    case Actions.FETCH_SUPER_DEALS_SUCCESS:
      return {
        ...state,
        superDeals: {
          ...state.superDeals,
          loading: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };
    case Actions.FETCH_SUPER_DEALS_FAILS:
      return {
        ...state,
        superDeals: {
          ...state.superDeals,
          loading: false,
          error: { status: true, message: action.payload }
        }
      };

    // Delete Super Deal
    case Actions.DELETE_SUPER_DEAL:
      return {
        ...state,
        superDeals: {
          ...state.superDeals,
          loading: true,
          error: { status: false, message: '' }
        }
      };
    case Actions.DELETE_SUPER_DEAL_SUCCESS:
      return {
        ...state,
        superDeals: {
          ...state.superDeals,
          loading: false,
          error: { status: false, message: '' },
          data: state.superDeals.data.filter(deal => deal.id !== action.payload)
        }
      };
    case Actions.DELETE_SUPER_DEAL_FAILS:
      return {
        ...state,
        superDeals: {
          ...state.superDeals,
          loading: false,
          error: { status: true, message: action.payload }
        }
      };

    default:
      return state;
  }
};